// SPDX-License-Identifier: AGPL-3.0-or-later

// The 3D room's canvas around a control of its overlay; null outside the room view.
export function roomCanvasOf(element: Element): HTMLCanvasElement | null {
	return (
		element
			.closest('[data-flx="voice-scene.voice-scene-view.scene"]')
			?.querySelector<HTMLCanvasElement>('[data-flx="voice-scene.voice-scene-view.stage"] canvas') ?? null
	);
}
